<ng-template #menuSection let-page="page">
  @for (entity of getMenuItemsForPage(page); track entity) {
    @if (entity.visible && entity.container) {
      <ng-container *ngTemplateOutlet="menuLine; context: {entity: entity}"></ng-container>
      @if (entity.open || containsCurrentPage(entity)) {
        <ion-list
          class="ion-padding-start ion-margin-start ion-no-padding">
          <ng-container *ngTemplateOutlet="menuSection; context: {page: entity.page}">
          </ng-container>
        </ion-list>
      }
    }
    @if (entity.visible && !entity.container) {
      <ion-menu-toggle auto-hide="false">
        <ng-container *ngTemplateOutlet="menuLine; context: {entity: entity}"></ng-container>
      </ion-menu-toggle>
      <ng-container *ngTemplateOutlet="menuSection; context: {page: entity.page}">
      </ng-container>
    }
  }
</ng-template>

<ng-template #menuLine let-entity="entity">
  @if (allowedAccess(entity)) {
    <ion-item (click)="entity.container ? (entity.open = !entity.open) : gotoPage(entity.page)" (keydown.enter)="entity.container ? (entity.open = !entity.open) : gotoPage(entity.page)"
      [class.highlight]="currentPage === entity.page"
      lines="full" button="true">
      @if (entity.icon && !entity.container) {
        <fa-icon [icon]="getFontAwesomeIcon(entity.icon)" class="fa-fw"></fa-icon>
      }
      @if (entity.container && (entity.open  || containsCurrentPage(entity))) {
        <fa-icon class="fa-fw"
        icon="caret-down"></fa-icon>
      }
      @if (entity.container && !(entity.open || containsCurrentPage(entity))) {
        <fa-icon class="fa-fw"
        icon="caret-right"></fa-icon>
      }
      <span class="ion-padding-start">{{ entity.title }}</span>
    </ion-item>
  }
</ng-template>


<ion-app [class.has-test-banner]="!!testBanner">
  @if (testBanner) {
    <div class="test-banner" [ngClass]="testBannerClass" role="status">{{ testBanner }}</div>
  }
  <ion-split-pane [when]="whenShowMenu" contentId="main">
    @if (canShowMenu()) {
      <ion-menu class="ion-no-padding" contentId="main" id="ion-menu" menuId="side-menu"
        side="start" type="overlay">
        <ion-header>
          <ion-toolbar color="secondary">
            <ion-title slot="start">Site Menu</ion-title>
            @if (!(isHandset$ | async)) {
              <ion-buttons slot="end">
                <ion-button (click)="setMenuPinned(menuPinned)" [fill]="menuPinned ? 'solid' : 'outline'"
                  color="light">
                  <fa-icon class="fa-fw" icon="thumbtack"></fa-icon>
                </ion-button>
              </ion-buttons>
            }
          </ion-toolbar>
        </ion-header>
        <ion-content>
          <ng-container *ngTemplateOutlet="menuSection; context: {page: undefined}">
          </ng-container>
        </ion-content>
      </ion-menu>
    }

    <ion-router-outlet id="main"></ion-router-outlet>
  </ion-split-pane>
</ion-app>
